/*
 * File: /src/store/modules/reservations.js
 * Created Date: Tuesday November 30th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 30th November 2021 5:52:55 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import reservationService from 'src/services/reservationServices';

const state = {
  // Currently these are use defined strings from the PMS
  // eventually type them into our models
  reservationTypes: undefined,
};

const getters = {
  getReservationTypes: state  => {
    return state.reservationTypes;
  },
};

const actions = {
  fetchReservationTypes({ commit }) {
    if (state.reservationTypes === undefined) {
      return reservationService
        .fetchReservationTypes()
        .then(response => {
          commit('setReservationTypes', response.data);
          return response;
        });
    }
  },
  unloadReservationTypes({ commit }) {
    commit('setReservationTypes', undefined);
  },
};

const mutations = {
  setReservationTypes(state, statuses) {
    state.reservationTypes = Object.assign([], statuses);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
